let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j6IGj")).then(() => parcelRequire('88y6K'));